'use es6';

import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { DATA, STATUS } from 'conversations-async-data/async-data/constants/keyPaths';
import { SUCCEEDED } from 'conversations-async-data/async-data/constants/asyncStatuses';
import { Map as ImmutableMap } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';
import setIn from 'transmute/setIn';
import { getResponders } from '../../responders/selectors/getResponders';
import { getResponderAsSender } from '../operators/getResponderAsSender';
import { getResponderKeyAsSenderLocator } from '../operators/getResponderKeyAsSenderLocator';
export const getSendersMap = createSelector([getResponders], respondersMap => {
  return respondersMap.reduce((sendersMap, responder, responderKey) => {
    return setIn([getResponderKeyAsSenderLocator(responderKey)], AsyncData({
      [DATA]: responder ? getResponderAsSender(responder) : null,
      [STATUS]: SUCCEEDED
    }), sendersMap);
  }, ImmutableMap());
});